"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.31,14.65A4.69,4.69,0,1,0,24,19.34a4.69,4.69,0,0,0-4.69-4.69Zm0,.79A3.9,3.9,0,0,1,23,18H15.65a3.89,3.89,0,0,1,3.66-2.6Zm0,4.69a.65.65,0,1,1,.65-.65.65.65,0,0,1-.65.65Zm-3.9-.79c1.78,0,3.21,1.71,3.24,3.83a3.9,3.9,0,0,1-3.24-3.83ZM20,23.18c0-2.12,1.47-3.83,3.24-3.83A3.9,3.9,0,0,1,20,23.18Zm-.06-.38",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.54,19.34A5.76,5.76,0,0,1,16,14.64l-.3-.11a4.68,4.68,0,0,0-1.61-1.28V11.87a4,4,0,0,0,1.39-2.76,2.19,2.19,0,0,0,.09-2.81C16,5,16.67,3.49,16.4,2.17,16.08.55,13.77,0,11.9,0,10.44,0,8.67.34,8.12,1.34A1.77,1.77,0,0,0,6.83,2C6,3.13,6.57,4.82,7,6.29A2.21,2.21,0,0,0,7,9.12a4,4,0,0,0,1.4,2.75h0v1.37a4.68,4.68,0,0,0-1.61,1.28c-3.22,1.22-5.08,1.94-5.75,3C.07,19,0,21.9,0,22s7.89.21,14.33.18A5.71,5.71,0,0,1,13.54,19.34Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;